import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${BACKEND_URL}/api` });

api.interceptors.request.use((config) => {
  const raw = localStorage.getItem("agp_user");
  if (raw) {
    try {
      const u = JSON.parse(raw);
      config.headers["X-User-Id"] = u.id;
    } catch (e) { /* noop */ }
  }
  return config;
});

export const apiError = (e) =>
  e?.response?.data?.detail || e?.message || "Error inesperado";
